import './likert-molecule-component.scss'
import { useLikertMoleculeController } from './likert-molecule-component-controller.js'
import {
    For,
    Show,
} from 'solid-js'
import ButtonAtomComponent from '../../atoms/button-atom/button-atom-component.jsx'
import CustomSVG from '../../atoms/custom-svg.jsx'

export default function LikertMoleculeComponent (props) {
    const controller = useLikertMoleculeController(props);

    return (
        <div class='likert-molecule' classList={controller.getContainerClasses()}>
            {/* Question */}
            <div class="likert-molecule__question">
                {props.question}
            </div>

            {/* Rating Scale */}
            <div
                classList={{
                    'likert-molecule__scale': true,
                    'likert-molecule__scale--bordered': props.showBorders,
                }}
            >
                <For each={props.options}>
                    {(option, index) => (
                        <div class="likert-molecule__option">
                            {/* Rating Icon Button */}
                            <ButtonAtomComponent
                                class='likert-molecule__icon-button'
                                classList={controller.getIconButtonClasses(option.value)}
                                onClick={() => controller.handleSelect(option.value)}
                            >
                                <Show when={ controller.isCircleStyle()}>

                                    <Show when={controller.isSelected(option.value)}>
                                        <CustomSVG path='icons/radio-selected' />
                                    </Show>
                                    <Show when={!controller.isSelected(option.value)}>
                                        <CustomSVG path='icons/radio-deselected' />
                                    </Show>
                                </Show>
                                <Show when={!controller.isCircleStyle()}>
                                    <CustomSVG path={controller.getIconPath(option)} />
                                </Show>
                            </ButtonAtomComponent>

                            {/* Label */}
                            <div class="likert-molecule__label">
                                {option.label}
                            </div>
                        </div>
                    )}
                </For>
            </div>
        </div>
    );
}